import { css } from '@emotion/react'
import { colors } from 'parameters/ui'
import { StrictUnion } from '../../../../../lib/types/strictUnions'

interface Props {
	bold?: true
	light?: true
	italic?: true
	highlight?: true
}

type SizeProps = { big?: true; small?: false } | { small?: true; big?: false }

export type TextEmphasisProps = StrictUnion<Props & SizeProps>

const FONTSIZE_STEP = 0.125

export const TextEmphasisMods = ({ italic, light, bold, small, big, highlight }: TextEmphasisProps) =>
	css([
		italic && css({ fontStyle: 'italic' }),
		bold && css({ fontWeight: 'bold' }),
		light && css({ color: colors.primaryDarkGrey1 }),
		big && css({ fontSize: `calc(1em + ${FONTSIZE_STEP}em)` }),
		small && css({ fontSize: `calc(1em - ${FONTSIZE_STEP}em)` }),
		highlight && css({ color: colors.orange1, fontStyle: 'normal' })
	])
